import { render } from "./Mugs.vue?vue&type=template&id=5f5a9d2e"
import script from "./Mugs.vue?vue&type=script&lang=js"
export * from "./Mugs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__